module.exports = {
  language: {
    name: 'English',
    current: 'Current Language',
  },
  // 头部
  common: {
    pagination: '共{allNum}条',
    more: 'More',
    consult: 'Enquries ',
    talk: 'Talk',
    favorites: 'Favorites',
    cancel: 'Cancel',
    collected: 'MY Exhibitors',
    collect: 'collect',
    clear: 'Clear',
    clearCollect: 'Remove from MY folder',
    collectExhibits: 'MY Exhibits',
    collectExhibition: 'Save this exhibitor',
    collectLive: 'Save this Live Broadcast',
    collectActivity: 'MY Favorite Activities',
    screenConditions: 'Search Condition',
    screen1: 'Filter by Exhibits Categories',
    screen2: 'Filter by Exhibition Hall',
    hall: 'Hall',
    successCollect: 'Add to MY folder successfully！',
    cancelCollect: 'Cancel in My folder successfully！',
    boothNum1: 'Booth No.：',
    options: 'Operation',
    download: 'Download',
    viewMore: 'More',
    viewMoreMobile: 'More',
    close: 'close',
    sure: 'Sure',
    share: 'Share',
    mobileLive: 'Live',
  },
  navbar: {
    title: 'Organizing Committee of China Coal & Mining Expo 2023',
    theme: 'China Coal & Mining Expo 2023',
    time: 'New China International Exhibition Center (NCIEC), Beijing, China 25-26 October 2023',
    home: 'Home',
    exhibition: 'Exhibitors',
    exhibits: 'Exhibits',
    live: 'Live Broadcast',
    activity: 'Activities',
    onlineHall: 'Online Visit',
    VRview: 'VR Visit',
    imgView: 'Photos Tours',
    videoView: 'Video Tours',
    onlineWeb: 'Official Website',
    audienceLogin: 'Visitor Login',
    audienceCenter: 'Visitor Center',
    exhibitionLogin: 'Exhibitor Login',
    exhibitionCenter: 'Exhibitor Center',
    zh: 'Chinese',
    en: 'English',
    about: 'About Us',
    join: 'Join Us',
    contact: 'Contact US',
    join: 'I want to exhibit',
    exhibitionLists: 'Exhibition Lists',
    exhibitsLists: 'Exhibits Lists',
  },
  mobileRecommend: {
    UndergroundMining: 'Underground Mining',
    UndergroundTunneling: 'Underground Tunneling',
    UndergroundTransportation: 'Underground Transportation',
    CoalMineElectromechanicalandPower: 'Coal Mine Electromechanical and Power',
    CoalMineAuxiliaryProductionSystem: 'Coal Mine Auxiliary Production System',
    SMARTMineAutomation: 'SMART Mine & Automation',
    CoalProcessingUtilization: 'Coal Processing & Utilization',
    Open_AirMining: 'Open-Air Mining',
    CoalMineServicesandEngineering: 'Coal Mine Services and Engineering',
    MineMaterialInstrumentsandProcessing: 'Mine Material/ Instruments and Processing',
  },
  //   展商
  exhibition: {
    placeholder: 'Please enter exhibitor name ',
    boothNum: 'Booth No.',
    sendCard: 'Submit Name Card',
    noexhibition: 'No Search Results',
    detailTitle: 'Exhibitor Details',
    go: 'Go To',
    place: 'Booth',
    boothArea: 'Booth Size：',
    companyNature: 'Type of Enterprise：',
    companyAddress: 'Company Address：',
    companyWebsite: 'Company Website：',
    companyPhone: 'Company Phone：',
    companyEmail: 'Contact Email：',
    exhibitionIntroduce: 'Exhibitor Preview',
    productCenter: 'Exhibits Center',
    productSeries: 'Product Series',
    openMore: 'More',
    live: 'Exhibitor Live',
    activity: 'Exhibitor Activities',
    activityType: 'Type of Activities',
    news: 'Exhibitor News',
    informations: 'Exhibitor Information',
    infoName: 'File Name',
    infoSize: 'File Size',
    tip1: 'Please Login to Downlaod the Document!',
    lastPage: 'Last Article',
    nextPage: 'Next Article',
    allProducts: 'All Exhibits',
    allActivity: 'All Activities',
    mobileDetail: '+ Detail',
  },
  exhibits: {
    placeholder: 'Please fill in Product Name',
    noData: 'No filtering results',
    detailTitle: 'Exhibits Details',
    productModel: 'Product Model：',
    prosuctSeries: 'Product Series：',
    productCategory: 'Product Type：',
    productIntroduce: 'Exhibit Preview',
    productParameter: 'Exhibit Data',
    productTravelBrochure: 'Exhibit Promotion Material',
    infoName: 'Flyer File Name',
    other: 'Other Exhibits',
  },
  live: {
    placeholder: 'Please fill in keywords',
    tab1: '2023/10/25',
    tab2: '2023/10/26',
    tab3: '2023/10/27',
    tab4: '2023/10/28',
    tip: 'Scan the QR code to watch the Live Broadcast',
    detailTitle: 'Live Broadcast Details',
    liveIntroduce: 'Live Broadcast Preview',
  },
  activity: {
    placeholder: 'Please fill in keywords',
    all: 'All Exhibits',
    place: 'Venue',
    nodata: 'No data information at the moment',
    technicalMeeting: 'Technical Seminar',
    productLaunch: 'Product Launch',
    standActivities: 'Booth Activities',
    otherActivity: 'Others',
    detailTitle: 'Exhibits Details',
    startTime: 'Start ：',
    endTime: 'End：',
    placeBooth: 'Booth:',
    activityIntroduce: 'Activies Preview',
    forum: 'Forum'
  },
  footer: {
    title: 'Organizing Committee of China Coal & Mining Expo 2023',
    titleTop: 'Nineteenth session',
    titleBottom: 'Organizing Committee of China Coal & Mining Expo 2023',
    link: 'Quick Link',
    company: 'Together Expo Limited',
    weChatOfficialAccount: 'WeChat Official Account',
    qrCodeAttention: 'Please Scan the QR code to Follow Us ',
    mobileQrCodeAttention: 'Please scan the two-dimensional code, and pay attention to the WeChat official account.',
    copyright: 'Copyright : China Coal Consultant International',
    technicalSupport: 'Technical Support：中煤信息技术(北京)有限公司',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: 'Mining Machinery Building, No.192,Andingmenwai Avenue, Dongcheng District, Beijing,P.R.China',
    linkUrl: {
      viewcz: 'I want to exhibit',
      viewcg: 'I want to Visit',
      zwt: 'Floor Plan',
      zhrc: 'Exhibition Schedule ',
      hzZhanhui: 'Official Website',
      mjlt: 'Forum',
    },
    unit: {
      title1: 'Host ',
      title2: 'Co-Host',
      title3: 'Organizers',
      text1: 'China National Coal Association',
      text2: 'China National Coal Group Corp',
      text3: 'China Coal Consultant International',
    },
  },
  homePage: {
    quickFind: 'Find Exhibits / Exhibitors',
    quickFind1: 'Find Exhibitors',
    quickFind2: 'Find Exhibits',
    placeholder1: 'Please select',
    placeholder2: 'Please fill in keywords',
    productRecommend: 'Exhibits Highlight',
    search: 'Search ',
    vr: {
      title: 'Panoramic View of ',
      txt:
        'The Organizing Committee will present the panoramic view of the exhibition which covering all 8 halls in NCIEC with the latest VR technology. Online visitors can position the location, search exhibitors and exhibits and to have interactive exchanges with exhibitors. The China Coal & Mining Expo will be an ongoing online event platform to serve the industry. ',
    },
    exhibition: {
      title: "Exhibitors' Highlight",
      no: 'Not Available Now',
    },
    live: {
      title: 'Live Exhibition',
      qrAlt: 'QR Code',
    },
    activity: {
      title: 'Concurrent Activities',
    },
    handle: {
      handle0: 'Please Select Exhibits Category',
      handle1: 'Please Select Exhibitor Category',
    },
    searchCategory: {
      searchCategory0: 'Search by Exhibits',
      searchCategory1: 'Search by Exhibitor',
    },
  },
  message: {
    isLimit: 'You can login one account only!',
    audienceAccount: 'Please login with your visitor account!',
    noLogin: 'You have not yet Login to this platform. ',
    goLogin: 'Go login',
    isDownload: 'Do you want to download',
  },
  share: {
    friend: 'Share with friends',
    wechat: 'Share to wechat',
    link: 'Copy link',
  },
};
